import { render, staticRenderFns } from "./FinalizarAvisosContratoSemMovimentacao.vue?vue&type=template&id=7f061a0b&"
import script from "./FinalizarAvisosContratoSemMovimentacao.vue?vue&type=script&lang=js&"
export * from "./FinalizarAvisosContratoSemMovimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports